<div class="d-flex align-items-center">
  <div class="text-reduced-regular color-text-secondary text" [innerHTML]="payload.text"></div>
  <a [href]="payload.url" target="_blank" class="d-flex align-items-center justify-content-center ml-4 download">
    <svg-icon key="download" class="color-secondary"></svg-icon>
    <span class="text-reduced-bold color-secondary ml-1">{{ payload.name || 'No filename provided' }}</span>
  </a>
</div>
